const injectScriptToDOM = (url, defer = true) => {
  const script = document.createElement("script");
  script.id = "google-oauth2";
  script.src = url;
  script.async = true;
  script.defer = { defer };

  if (document.getElementById("google-oauth2") !== null) {
    return;
  } else {
    document.body.appendChild(script);
  }
};

export default injectScriptToDOM;
